import React from 'react'
import PropTypes from 'prop-types'
import nofollow from '../../../utils/helpers/nofollow'
import WrapperLink from './styled'

const Link = ({
  href,
  linkText,
  url,
  hoverColor,
  linkColor,
  target,
  children,
  hasArrow,
}) => (
  <WrapperLink
    href={href || url}
    target={target || '_self'}
    hoverColor={hoverColor}
    linkColor={linkColor}
    hasArrow={hasArrow}
    rel={nofollow(target)}
  >
    {linkText}
    {children}
  </WrapperLink>
)

Link.propTypes = {
  linkText: PropTypes.string,
  url: PropTypes.string,
  hoverColor: PropTypes.string,
  linkColor: PropTypes.string,
  target: PropTypes.string,
  children: PropTypes.node,
  href: PropTypes.string,
  hasArrow: PropTypes.bool,
}

export default Link



// WEBPACK FOOTER //
// ./includes/yoco-website-cms-gatsby/src/components/atoms/Link/Link.js